import React from 'react';

const StopIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 1.90875V20.0912C21.9993 20.5973 21.798 21.0824 21.4402 21.4402C21.0824 21.798 20.5973 21.9993 20.0912 22H1.90875C1.40272 21.9993 0.917607 21.798 0.559791 21.4402C0.201974 21.0824 0.000661477 20.5973 0 20.0912V1.90875C0.000661477 1.40272 0.201974 0.917607 0.559791 0.559791C0.917607 0.201974 1.40272 0.000661477 1.90875 0H20.0912C20.5973 0.000661477 21.0824 0.201974 21.4402 0.559791C21.798 0.917607 21.9993 1.40272 22 1.90875Z"
      fill="white"
    />
  </svg>
);

export default StopIcon;
